import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'

/**
 * Compact prescription-section header: a small square icon + title that always fits the width
 * (single line, ellipsised), the section's one-line description moved into a tappable info
 * button (tooltip on tap/hover — works on touch, unlike a hover-only caption), and an optional
 * right-side slot for per-section controls (undo/redo, print toggle).
 *
 * Keeps the section cards lean and consistent on phones while staying legible on desktop.
 */
export default function LeanSectionHeader({ icon, title, description, rightSlot, accentColor = '#4338ca' }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        mb: 1.5,
        pb: 1,
        borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
        <Box
          sx={{
            width: { xs: 26, sm: 30 },
            height: { xs: 26, sm: 30 },
            borderRadius: '7px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: `${accentColor}14`,
            color: accentColor,
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
        <Typography
          component="span"
          sx={{
            fontWeight: 700,
            color: '#1e293b',
            fontSize: { xs: 16, sm: 18 },
            lineHeight: 1.2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
          }}
        >
          {title}
        </Typography>
        {description ? (
          <Tooltip title={description} arrow placement="top" enterTouchDelay={0} leaveTouchDelay={5000}>
            <IconButton
              size="small"
              aria-label={`About ${title}`}
              sx={{ flexShrink: 0, color: '#94a3b8', p: '2px', '&:hover': { color: accentColor } }}
            >
              <InfoOutlinedIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        ) : null}
      </Box>
      {rightSlot ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>{rightSlot}</Box>
      ) : null}
    </Box>
  )
}
